cv.timeLeft = function(end_date, timezone) {
  var current_offset = moment.utc().tz(moment.tz.guess()).utcOffset();
  var campaign_offset = moment.utc().tz(timezone).utcOffset();
  console.log('current offset', current_offset); // 240
  console.log('campaign offset', campaign_offset); // 240

  var countdown_object = countdown(moment.utc().valueOf(), moment(cv.campaign.get('end_date') + 'Z').valueOf() - (campaign_offset * 60000), countdown.DEFAULTS, 1);
  return countdown_object.toString();
};
